import React from 'react'
import { Switch, Route, Link } from 'react-router-dom'
// import { useGlobalState } from 'state'

import Breadcrumbs from '@/Layout/Breadcrumbs'
import PageTitle from '@/Layout/PageTitle'

import SearchIndex from '@/pages/TalentSearch/SearchIndex'

function breadCrumbs() {
  // const location = useLocation()
  // const activePath = location.pathname
  // const [submission] = useGlobalState('submission')
  // will need this ^ when adding show/edit func, see creditscontainer
  const crumbs = [
    { to: '/talent', name: 'Search Talent' }
  ]
  return crumbs
}

function pageTitle() {
  // const location = useLocation()
  // const activePath = location.pathname
  // const [currentUser] = useGlobalState('currentUser')
  // const { id } = useParams()
  // const [submission] = useGlobalState('submission')
  // will need this ^ when adding show/edit func, see creditscontainer

  const titleInfo = {
    title: 'Search Talent',
    buttons: []
  }

  return titleInfo
}

export default function CoinsContainer(props) {
  const crumbs = breadCrumbs()
  const titleInfo = pageTitle()

  return <>
    <Breadcrumbs>
      { crumbs.map((crumb, index) => (
        <Link key={`${index}${crumb.name}`} to={crumb.to} className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 dark:text-gray-100">
          {crumb.name}
        </Link>
      ))}
    </Breadcrumbs>
    <PageTitle pagetitle={titleInfo.title}>
      {titleInfo.buttons}
    </PageTitle>
    <Switch>
      <Route {...props} path={['/talent', '/talent/:talent_type']}>
        <SearchIndex />
      </Route>
    </Switch>
  </>
}
